import { LocationManagementLocationType } from "./locationType";

export type LocationTypeMovementBlock = {
  id: string;
  fromLocationType: LocationManagementLocationType;
  toLocationType: LocationManagementLocationType;
  description: string;
};

export const defaultLocationTypeMovementBlock: LocationTypeMovementBlock = {
  id: "",
  fromLocationType: {
    id: "",
    name: "",
    allowNestedLocations: false,
  },
  toLocationType: {
    id: "",
    name: "",
    allowNestedLocations: false,
  },
  description: "",
};
